var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconColourCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.409,
    x2: 211.535,
    y1: 77.091,
    y2: 133.217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -103.982 217.432)",
    gradientUnits: "userSpaceOnUse",
    x1: 19.413,
    x2: 82.946,
    xlinkHref: "#lg1",
    y1: 163.946,
    y2: 227.48
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.175,
    x2: 73.828,
    xlinkHref: "#lg2",
    y1: 151.553,
    y2: 210.205
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.323,
    x2: 311.059,
    y1: 81.825,
    y2: 140.562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -103.982 217.432)",
    gradientUnits: "userSpaceOnUse",
    x1: 305.409,
    x2: 383.97,
    y1: 235.247,
    y2: 313.807
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.281,
    x2: 346.386,
    y1: 93.783,
    y2: 175.888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -103.982 217.432)",
    gradientUnits: "userSpaceOnUse",
    x1: 8.093,
    x2: 100.534,
    xlinkHref: "#lg2",
    y1: 244.809,
    y2: 337.25
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -103.982 217.432)",
    gradientUnits: "userSpaceOnUse",
    x1: 206.596,
    x2: 284.147,
    y1: 351.13,
    y2: 428.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -103.982 217.432)",
    gradientUnits: "userSpaceOnUse",
    x1: 293.327,
    x2: 262.928,
    y1: 437.86,
    y2: 407.461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -103.982 217.432)",
    gradientUnits: "userSpaceOnUse",
    x1: 74.219,
    x2: 261.743,
    xlinkHref: "#lg1",
    y1: 310.934,
    y2: 498.458
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    stopColor: "#6c335b",
    stopOpacity: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5241,
    stopColor: "#513153",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#402f4f",
    stopOpacity: 0.796
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.785,
    x2: 355.785,
    xlinkHref: "#lg3",
    y1: 170.248,
    y2: 244.994
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.381,
    x2: 76.357,
    xlinkHref: "#lg3",
    y1: 237.228,
    y2: 311.968
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.157,
    x2: 385.409,
    y1: 204.922,
    y2: 480.174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7acbff"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.324,
    x2: 393.419,
    xlinkHref: "#lg4",
    y1: 241.074,
    y2: 205.064
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.205,
    x2: 252.205,
    xlinkHref: "#lg4",
    y1: 437.482,
    y2: 505.958
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.688,
    x2: 177.938,
    y1: 245.067,
    y2: 304.881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m214.696 29.03v119.267c-24.426 0-48.851 9.315-67.482 27.946l-84.331-84.33c41.92-41.92 96.867-62.891 151.813-62.883z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.268 243.726c0 24.426 9.315 48.851 27.946 67.482l-84.331 84.331c-41.919-41.92-62.89-96.866-62.883-151.813z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.883 91.913 84.331 84.331c-18.631 18.631-27.946 43.057-27.946 67.482h-119.268c-.007-54.947 20.964-109.893 62.883-151.813z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.509 91.913-84.331 84.331c-18.631-18.631-43.057-27.946-67.482-27.946v-119.267c54.947-.009 109.894 20.962 151.813 62.882z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.509 91.913c41.92 41.92 62.891 96.866 62.883 151.813h-119.267c0-24.426-9.315-48.851-27.946-67.482z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.509 91.913c41.92 41.92 62.891 96.866 62.883 151.813h-119.267c0-24.426-9.315-48.851-27.946-67.482z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.696 339.155v119.267c-54.947.007-109.893-20.963-151.813-62.883l84.331-84.331c18.631 18.631 43.057 27.947 67.482 27.947z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.392 243.726c.007 54.947-20.963 109.893-62.883 151.813l-84.331-84.331c18.631-18.631 27.946-43.057 27.946-67.482z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.392 243.726c.007 54.947-20.963 109.893-62.883 151.813l-84.331-84.331c18.631-18.631 27.946-43.057 27.946-67.482z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.178 311.208 84.331 84.331c-41.92 41.92-96.866 62.891-151.813 62.883v-119.267c24.426 0 48.851-9.316 67.482-27.947z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m282.178 176.244c18.631 18.631 27.946 43.057 27.946 67.482h119.268c.004-28.417-5.618-56.828-16.832-83.443h-114.421z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.311 220.075c-.865 7.858-1.312 15.754-1.311 23.651-.007 54.947 20.963 109.893 62.883 151.813l84.331-84.331c-18.631-18.631-27.947-43.057-27.947-67.482 0-7.952 1.005-15.899 2.98-23.651z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m369.706 200.381c-15.21 0-29.85 2.43-43.566 6.907-14.67-47.862-59.206-82.665-111.874-82.665-64.616 0-116.997 52.381-116.997 116.997 0 9.336 1.1 18.415 3.166 27.119-55.143 3.887-98.672 49.847-98.672 105.98 0 58.681 47.57 106.252 106.252 106.252h261.691c77.482-.001 140.294-62.813 140.294-140.295s-62.812-140.295-140.294-140.295z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.408 340.681c0 5.691.342 11.299 1.004 16.812-5.277.744-10.673 1.122-16.151 1.122-64.616 0-116.989-52.385-116.989-117.001 0-64.604 52.373-116.989 116.989-116.989 52.668 0 97.213 34.805 111.877 82.668-56.151 18.312-96.73 71.11-96.73 133.388z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.581 387.944c6.511 52.439 51.231 93.026 105.433 93.026h261.691c60.895 0 112.721-38.801 132.123-93.026z",
    fill: "url(#SVGID_15_)"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 188.092,
    cy: 315.131,
    fill: "url(#SVGID_16_)",
    r: 86.255
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColourCloud);
export default __webpack_public_path__ + "static/media/icon-colour-cloud.788951ddbd39148636908f72470499a5.svg";
export { ForwardRef as ReactComponent };